import { DateTime } from "luxon";

export const isTimeString = (timeString: string) => {
  return !timeString || DateTime.fromFormat(timeString, "HH:mm").isValid;
}

export const isDateTime = (dateTimeString: string) => {
  return !dateTimeString || DateTime.fromISO(dateTimeString).isValid;
}
